module.exports = __webpack_public_path__ + "img/2024-03-19b_3.393695a4.jpg";